export default __webpack_public_path__ + "static/media/bootstrapp.5b6ec4d1.png";